module.exports = __webpack_public_path__ + "static/media/spot20.db2c4f86.webp";